<template>
  <div
    :key="$route.params.artist"
    class="section pt-0"
  >
    <div class="container">
      <v-timeline
        :artist="artist"
      />
    </div>
  </div>
</template>

<script>

import Timeline from "@/components/timeline/Timeline.vue";

export default {
	components: {
		"v-timeline": Timeline
	},
	computed: {
		artist () {
			return this.$store.state.artists[this.$route.params.artist];
		}
	}
};
</script>
